import { render, staticRenderFns } from "./SearchHistoryView.vue?vue&type=template&id=8ff5f908"
import script from "./SearchHistoryView.vue?vue&type=script&lang=js"
export * from "./SearchHistoryView.vue?vue&type=script&lang=js"
import style0 from "./SearchHistoryView.vue?vue&type=style&index=0&id=8ff5f908&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports